import { mapState, mapMutations } from "vuex";

export default {
  computed: {
    ...mapState({
      longTablePart: state => state.stat.longTablePart,
    }),

    isLongTable() {
      return this.longTablePart === this.longTableId;
    },
  },

  beforeDestroy() {
    this.setLongTablePart(null);
  },

  methods: {
    ...mapMutations({
      setLongTablePart: "setLongTablePart",
    }),
  },
};
